
@switch (vendorType) {
  @case ('KYRUUS') {
    <app-doctor-information-kyruus
      [title]="title"
      [subTitle]="subTitle"
      [description]="description"
      [primaryCareProviderOnly]="primaryCareProviderOnly"
      [nextButtonLabel]="nextButtonLabel"
      [nextButtonUrl]="nextButtonUrl"
      [backButtonLabel]="backButtonLabel"
      [backButtonUrl]="backButtonUrl"
      [market]="market"
      [defaultRadius]="defaultRadius"
      (doctorsChanged)="doctorsChanged.emit($event)"
    ></app-doctor-information-kyruus>
  }
  @case ('SAPPHIRE_DIGITAL') {
    <app-doctor-information-sapphire-digital
      [title]="title"
      [subTitle]="subTitle"
      [description]="description"
      [primaryCareProviderOnly]="primaryCareProviderOnly"
      [nextButtonLabel]="nextButtonLabel"
      [nextButtonUrl]="nextButtonUrl"
      [backButtonLabel]="backButtonLabel"
      [backButtonUrl]="backButtonUrl"
      [market]="market"
      [defaultRadius]="defaultRadius"
      (doctorsChanged)="doctorsChanged.emit($event)"
      [useBrandNetwork]="useBrandNetwork"
    ></app-doctor-information-sapphire-digital>
  }
  @default {
    Choose a provider vendor
  }
}
